import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import hqLogoBlack from '../assets/images/hqrent-black.png'
import hqLogoWhite from '../assets/images/hqrent-white.png'
import { dividerStyles } from '../core/constants/styles'
import { useSelector } from 'react-redux';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const headerTheme = useSelector((state: any) => state.setting.headerTheme);
  let layoutFlag = true;
  if (location.pathname === '/shoppingcart' || location.pathname === '/checkout' || location.pathname === '/orderconfirmation') layoutFlag = false;
  const footerColor = headerTheme === 'white' ? ' bg-white ' : ' bg-darkGreen ';
  const fontColor = headerTheme === 'white' ? ' text-black ' : ' text-lemonGrass ';
  const hqLogo = headerTheme === 'white' ? hqLogoBlack : hqLogoWhite;
  const isNotFoundPage = location.pathname === '/404';

  return (
    <div className={isNotFoundPage ? 'mt-0' : 'mt-25 sm:pb-0 pb-96'}>
	  <div className={footerColor + fontColor} data-testid="footer-container">
        <div className="max-w-mxWidth mx-auto">
          <div className={" text-16 " + (layoutFlag ? 'pt-20 ' : '')}>
            <div className={`${dividerStyles.horizontal} mb-20`} />
              <div className='flex flex-wrap items-center justify-between'>
                <div className="mx-20">
                  <img
                    className='h-20 min-h-20 cursor-pointer'
                    src={hqLogo}
                    alt=''
                    data-testid="footer-logo-link"
                    onClick={() => {
                      window.open('https://hqrent.com', '_blank');
                    }}
                  />
                  <p className="my-16 whitespace-nowrap">The best trailer rental software.</p>
                </div>
                <div className="flex flex-wrap mx-20">
                  <p
                    className="mr-24 my-8 cursor-pointer whitespace-nowrap"
                    data-testid="footer-privacy-policy-link"
                    onClick={() => navigate('/privacy-policy')}
                  >
                    Privacy Policy
                  </p>
                  <p
                    className="mr-24 my-8 cursor-pointer whitespace-nowrap"
                    data-testid="footer-terms-of-service-link"
                    onClick={() => navigate('/terms-service')}
                  >
                    Terms of Service
                  </p>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Footer;